import { useState, useEffect } from "react";

const images = [
  "/sleeve1.webp",
  "/sleeve2.webp",
];

const Ad = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full my-6">
      <div id="sleeve-rental-ad" className="relative overflow-hidden bg-haskurit-gray shadow-2xl flex flex-col lg:flex-row-reverse">
        <div className="relative w-full h-64 sm:h-80 lg:h-auto lg:flex-1 overflow-hidden bg-haskurit-gray">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="שרוולים לפינוי פסולת בנייה"
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${index === currentImage ? "opacity-100 z-10" : "opacity-0 z-0"
                }`}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-l from-haskurit-gray via-transparent to-transparent hidden lg:block z-20" />
        </div>

        <div className="relative z-20 flex-[1.4] p-6 md:p-10 lg:p-12 flex flex-col justify-center items-start text-right">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-haskurit-yellow mb-4 leading-tight w-full">
            השכרת שרוולים לפינוי פסולת
          </h1>
          <div className="space-y-3 text-white text-base md:text-lg lg:text-xl leading-relaxed">
            <p>
              זקוק לפנות פסולת בנין בצורה מבוקרת ומאורגנת?
            </p>
            <p className="opacity-95">
              <span className="font-bold">'השכורית'</span> מספקים לך שרוולים איכותיים ועמידים במיוחד, כולל התקנה ופירוק, קשירה ומתיחה, שמיכות, וליווי צמוד לכל צורך שעולה בשטח.
            </p>
            <p className="opacity-90 leading-relaxed">
              אצלנו תקבל זמינות והתאמה מושלמת לפרויקט, תמחור הוגן ומשתלם, וכמובן השכרת כלים נלווים.
            </p>
          </div>
          <div className="mt-6 pt-4 border-t border-white/10 w-full">
            <p className="text-haskurit-yellow font-bold text-lg md:text-xl lg:text-2xl leading-snug">
              ותזכור, לקחת ציוד מ'השכורית' זה לקבל מעטפת שירות עם חיוך!
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Ad;